import { Injectable, signal, effect } from '@angular/core';
import { toObservable } from '@angular/core/rxjs-interop';
import { Observable } from 'rxjs';

export type Theme = 'light' | 'dark';

@Injectable({
  providedIn: 'root'
})
export class ThemeService {
  private readonly THEME_KEY = 'app-theme';
  
  // Signal to hold theme state
  theme = signal<Theme>(this.getInitialTheme());

  // Convert signal to observable for continuous emission
  theme$ = toObservable(this.theme);

  constructor() {
    effect(() => {
      const currentTheme = this.theme();
      this.applyTheme(currentTheme);
      this.saveTheme(currentTheme);
    });
  }

  toggleTheme(): void {
    this.theme.update(current => current === 'light' ? 'dark' : 'light');
  }

  setTheme(theme: Theme): void {
    this.theme.set(theme);
  }

  getTheme(): Theme {
    return this.theme();
  }

  getThemeObservable(): Observable<Theme> {
    return this.theme$;
  }

  // private getInitialTheme(): Theme {
  //   const savedTheme = localStorage.getItem(this.THEME_KEY) as Theme | null;
  //   if (savedTheme === 'light' || savedTheme === 'dark') {
  //     return savedTheme;
  //   }

  //   if (typeof window !== 'undefined' && window.matchMedia) {
  //     return window.matchMedia('(prefers-color-scheme: dark)').matches ? 'dark' : 'light';
  //   }

  //   return 'light';
  // }
  private getInitialTheme(): Theme {
    if (typeof localStorage !== 'undefined') {
      const savedTheme = localStorage.getItem(this.THEME_KEY) as Theme | null;
      if (savedTheme === 'light' || savedTheme === 'dark') {
        return savedTheme;
      }
    }
    return 'light';
  }

  private applyTheme(theme: Theme): void {
    if (typeof document !== 'undefined') {
      const html = document.documentElement;
      html.classList.toggle('dark', theme === 'dark');
    }
  }

  private saveTheme(theme: Theme): void {
    if (typeof localStorage !== 'undefined') {
      localStorage.setItem(this.THEME_KEY, theme);
    }
  }
}
